import { FC } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
//--
import "./SCUStepper.scss";

interface IProps {
  stepList: Array<{ id: number; name: string }>;
  activeStep: number;
  onClick?: any;
  className?: string;
}

export const SCUIStepper: FC<IProps> = ({
  stepList,
  activeStep,
  onClick,
  className,
}) => {
  className = className
    ? "sc-stepper__header " + className
    : "sc-stepper__header";

  return (
    <div className="sc-stepper">
      <Stepper activeStep={activeStep} alternativeLabel className={className}>
        {stepList.length &&
          stepList.map((item) => (
            <Step
              key={item.id.toString()}
              onClick={() => onClick(item.id && item.id)}
            >
              <StepLabel>{item.name}</StepLabel>
            </Step>
          ))}
      </Stepper>
      {/* <div className="sc-stepper__content">
        {activeStep === stepList.length ? (
          <div className="sc-stepper__content-message">
            <Typography className="txt-done">
              Tüm adımları bitirdiniz.
            </Typography>
            <SCUIButton
              text="Adımları Sıfırla"
              type="primary"
              sizeType="default"
              size="l"
              onClick={onClickReset}
            />
          </div>
        ) : (
          <div className="sc-stepper__content-form">
            <div className="sc-stepper__content-form-wrapper">{children}</div>
            <div className="sc-stepper__content-form-footer">
              {/*<Button
                disabled={activeStep === 0}
                onClick={_handleBack}
                className={classes.backButton}
              >
                Geri
              </Button>
              {showBottomBtn && (
                <SCUIButton
                  text={
                    activeStep === stepList.length - 1
                      ? "Başvuruyu tamamla"
                      : "Devam et"
                  }
                  type="primary"
                  sizeType="default"
                  size="l"
                  onClick={onClickNext}
                />
              )}
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
};
